import PropTypes from 'prop-types'

import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {BASE_CLASS} from '../../config/index.js'

export default function ModalContent({captionText, children, headerImage, title, titleSize}) {
  return (
    <div className={`${BASE_CLASS}-stepsContent`}>
      {headerImage ? <div className={`${BASE_CLASS}-headerImage`}>{headerImage}</div> : null}
      {captionText ? <div className={`${BASE_CLASS}-captionText`}>{captionText}</div> : null}
      {title ? (
        <div className={`${BASE_CLASS}-title`}>
          <TitleBasic as={titleBasicTags.h1} size={titleBasicSizes[titleSize]} title={title} />
        </div>
      ) : null}
      <div className={`${BASE_CLASS}-children`}>{children}</div>
    </div>
  )
}

ModalContent.displayName = 'ModalContent'
ModalContent.propTypes = {
  captionText: PropTypes.string,
  children: PropTypes.node,
  headerImage: PropTypes.node,
  title: PropTypes.string,
  titleSize: PropTypes.string
}
